import axios from 'axios'

const password = 'password'

export default {
  forgotPassword (context, data) {
    axios.post(password, data).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setForgotRequestSent(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setForgotRequestNotSent(error.response.data.return_message)
    })
  },
  verifyPassword (context, token1, name1) {
    const params = {params: {token: token1, name: name1}}
    axios.get(password, params).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setValidToken(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setNotValidToken(error.response.data.return_message)
    })
  },
  updatePassword (context, data) {
    axios.put(password, data).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setPasswordUpdated(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setPasswordNotUpdated(error.response.data.return_message)
    })
  },
  getFullVacantProperties (context) {
    axios.get(`${password}/property/full-list`).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setFullVacantProperties(response.data)
    }, () => {
    })
  },
  addContact (context, body) {
    axios.post(`${password}/contact-us`, body).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.contactAdded(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.contactNotAdded(error.response.data.return_message)
    })
  }}
